import React, {useEffect, useState} from 'react'
import './ToDoEnd.min.css'
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import axios from 'axios';
import ToDoEndGroup from './ToDoEndGroup';
import { ipAddress } from '../../ipAddress';


interface Group {
  name: string,
  id: number,
  isDone: number,
  date: string,
}


const ToDoEnd: React.FC = () => {
const [downloadGroups, setDownloadGroups] = useState<Group[]>([]);
 
const downloadGroupsDone = () => {
  axios.post(ipAddress + '/downloadGroupsDone')
  .then((response) => {
    setDownloadGroups(response.data);
  })
}

useEffect(() => {
  downloadGroupsDone();

 
}, [downloadGroups])

for (let i = 0; i < downloadGroups.length; i++) {
  var date2 = new Date();
  let date1 = new Date(downloadGroups[i].date);
  //var dateFormart = new Date(`"${month}/${day}/${year}"`);
  var timeDiff = Math.abs(date2.getTime() - date1.getTime());
  var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)); 
  if(diffDays > 7 ){
    axios.post(ipAddress + "/deleteGroup", {
        id: downloadGroups[i].id
      })
      axios.post(ipAddress + '/deleteTask2', {
          id: downloadGroups[i].id,
        })
      
      
  }

}





  return (

    <div className='toDoEnd'>
      <div className='title'>
        <Link to='/ToDo'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>To do</span>
      </div>
      <div className='toDoEnd2'>
        <Link to='/ToDo'>Zaplanowane</Link>
        <Link to='/ToDo/Zakonczone'>Zakończone</Link>
      </div>

      <Outlet />

      {
        downloadGroups.map((group) => (
          <ToDoEndGroup group={group} key={group.id}/>
        ))
      }

    </div>
  )
}

export default ToDoEnd